import React from "react";
import { useLocation, useNavigate } from "react-router-dom";

const UserTabs = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const tabs = [
    {
      label: "Surveyors",
      path: "/admin/users-registrations"
    },
    {
      label: "Calculation Rules",
      path: "/admin/calculation-rules"
    }
  ];

  const isActive = (path) => {
    return location.pathname.startsWith(path);
  };

  return (
    <div className="tenant-people-tabs">
      {tabs.map((tab) => (
        <button
          key={tab.path}
          type="button"
          className={`tenant-people-tab ${
            isActive(tab.path) ? "tenant-people-tab-active" : ""
          }`}
          onClick={() => navigate(tab.path)}
        >
          {tab.label}
        </button>
      ))}
    </div>
  );
};

export default UserTabs;